import React from 'react';
import { Col } from 'react-bootstrap';

const Message = () => (
  <Col className="bg-warning w-100 text-lg-center p-5">
    <h1>Narrativa’s COVID-19 API will no longer be available...:(</h1>
    <h3>
      For details please check this&nbsp;
      <span className="text-right">
        <a href="https://www.narrativa.com/narrativa-covid-19-tracking-project-will-no-longer-be-available/">
          link
        </a>
      </span>
    </h3>
  </Col>
);
export default Message;
